import _ from 'lodash';

import { converter } from '../converter';
import templates from '../templates';
import { destroyIntercom, openIntercom } from '../../../helpers/intercom.helper';

const Container = (() => {
    class ChartContainer {
        constructor () {
            this._export = this._export.bind(this);
            this._fullscreen = this._fullscreen.bind(this);
            this._table = this._table.bind(this);
        }

        _export (btn, name) {
            converter.csv({
                name: String(this.options.filename || name).toUnderscoreCase(),
                type: 'charts',
                data: this.dataTable.convertToTable(),
                button: btn
            });
        }

        _fullscreen (btn) {
            $(btn).on('click', e => {
                e.preventDefault();

                this.wrapper.isFullscreen = !this.wrapper.isFullscreen;

                const chartSize = this.options.small ? 'chart-small-size' : 'chart-normal-size';
                $(this.wrapper.container).toggleClass(chartSize );
                $(this.wrapper.container).toggleClass('chart-expanded-size');

                const scope = this.wrapper.isFullscreen ? '#center-pane .middle-content' : this.wrapper.parent;
                const title = this.wrapper.isFullscreen ? 'Minimizar' : 'Maximizar';
                $(this.wrapper.container).detach().appendTo(scope);

                this._drawChart();
                if ($(this.wrapper.table).is(':visible') && this._drawTable) {
                    this._drawTable();
                }

                $(btn).find("i").toggleClass("fa-expand fa-compress");
                $(btn).attr('title', title);

                if (this.wrapper.isFullscreen) {
                    destroyIntercom();
                } else {
                    openIntercom();
                }
            });
        }

        _table (btn) {

            $(btn).on('click', e => {
                e.preventDefault();
                if ($(this.wrapper.table).is(':hidden')) {
                    this.wrapper.buttons.table.innerHTML = '<i class="fa fa-bar-chart-o"></i>';
                    this._drawTable();
                } else {
                    this.wrapper.buttons.table.innerHTML = '<i class="fa fa-table"></i>';
                    $(this.wrapper.chart).show();
                    $(this.wrapper.table).hide();
                    this._drawChart();
                }
            });
        }

        _createChartWrapper (options) {
            const buttons = {
                custom (button) {
                    return {
                        icon: button.icon,
                        name: button.text,
                        title: button.name,
                        click: (el) => {
                            el.on('click', e => {
                                e.preventDefault();
                                button.callback();
                            });
                        }
                    };
                },
                secondCustom (button) {
                    return {
                        icon: button.icon,
                        name: button.text,
                        title: button.name,
                        click: (el) => {
                            el.on('click', e => {
                                e.preventDefault();
                                button.callback();
                            });
                        }
                    };
                },
                excel (button) {
                    return {
                        icon: button.icon,
                        name: button.text,
                        title: button.name,
                        click: (ex) => {
                            ex.on('click', e => {
                                e.preventDefault();
                                button.callback();
                            });
                        }
                    };
                },
                table: () => {
                    return {
                        icon: 'table',
                        name: 'table',
                        title: 'Tabela',
                        click: this._table
                    };
                },
                fullscreen: () => {
                    return {
                        icon: 'expand',
                        name: 'fullscreen',
                        title: 'Maximizar',
                        click: this._fullscreen
                    };
                },
                export: () => {
                    if (options.buttons.export) {
                        return {
                            icon: 'download',
                            name: 'export',
                            title: 'Exportar',
                            click: this._export
                        };
                    }
                }
            };

            const values = {
                small: !!this.options.small,
                title: options.title,
                buttons: _.map(options.buttons, (val, key) => {
                    if (!val) {
                        return null;
                    }

                    return buttons[key](val);
                }).filter(x => x != null),
                height: options.height ? `${options.height + 14}px` : undefined
            };

            const $template = $(templates('dashboard-chart-container', values));
            return {
                header: $template.find('.chart-header'),
                buttons: _.reduce(options.buttons, (res, val, key) => {
                    if (!val) {
                        return res;
                    }

                    res[key] = $template.find(`a[data-name=${key}]`);
                    buttons[key](val).click(res[key], options.title);
                    return res;
                }, {}),
                container: $template,
                content: $template.find('.chart-content'),
                chart: $template.find('.chart-graph'),
                table: $template.find('.chart-table'),
                parent: null,
                isFullscreen: false
            };
        }
    }

    return ChartContainer;
})();

export default Container;



// WEBPACK FOOTER //
// ./src/scripts/core/charts/Container.js